import { render, staticRenderFns } from "./ChargingPointTypeDetail.vue?vue&type=template&id=57080f63"
import script from "./ChargingPointTypeDetail.vue?vue&type=script&lang=js"
export * from "./ChargingPointTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports